export default {
    getTeacherIndicators:       { method: 'get', url: 'teacher_indicators' },
    postTeacherIndicators:      { method: 'post', url: 'teacher_indicators' },
    putTeacherIndicators:       { method: 'put', url: 'teacher_indicators/{id}' },
    deleteTeacherIndicators:    { method: 'delete', url: 'teacher_indicators/{id}' },
    indexVariationStatuses:     { method: 'get', url: 'teacher_indicators/variation_statuses' },
    summaryByWorkRegime:        { method: 'get', url: 'teacher_indicators/summary-by-work-regime' },
    summaryByTitling:           { method: 'get', url: 'teacher_indicators/summary-by-titling' },
    summaryByTitlingDetail:     { method: 'get', url: 'teacher_indicators/summary-by-titling-detail' },
    summaryActiveTeachers:      { method: 'get', url: 'teacher_indicators/summary-active-teachers' },
    activeTeachersList:         { method: 'get', url: 'teacher_indicators/active-teachers' },
    summaryByCourse:            { method: 'get', url: 'teacher_indicators/summary-by-course' },
    summaryChByRegime:          { method: 'get', url: 'teacher_indicators/summary-ch-by-regime' },
    workRegimeHistory:          { method: 'get', url: 'teacher_indicators/work-regime-history' }
}
